import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ImagePlaceholderPageConfig } from '../types'
import { IMAGE_PLACEHOLDER_COMPONENTS_TYPES } from '../imagePlaceholderComponentTypes'
import { name } from '../symbols'

const imagePlaceholderPageConfig: PageConfigFn<ImagePlaceholderPageConfig> = ({ api }: VsmContext) => {
	let hasComponents = false
	for (const compType of IMAGE_PLACEHOLDER_COMPONENTS_TYPES) {
		const comps = api.components.getComponentsByType(compType)
		if (Object.keys(comps).length > 0) {
			hasComponents = true
			break
		}
	}

	if (!hasComponents) {
		return { shouldLoadPageFeature: false }
	}

	const protocol = api.env.isHttps() ? 'https:' : 'http:'
	const publicTopology = api.env.getPublicTopology()
	const staticMediaUrl = `${protocol}${publicTopology?.staticMediaUrl ?? ''}`

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			staticMediaUrl,
			isSEOBot: api.env.isInSeo(),
		},
	}
}

export const pageConfig: PageConfigEntry<ImagePlaceholderPageConfig> = {
	name,
	configFactory: imagePlaceholderPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
